import axios from 'axios'
import { getAuthToken } from './authToken'

// Authenticated <img> sources: images live behind /api/media/*, which needs a
// bearer token the browser won't attach to <img>. We fetch each as a blob once
// and hand back an object URL (memoized for the session).
const cache = new Map()
const inflight = new Map()

export function mediaRawUrl(relativePath) {
  if (!relativePath) return null
  let rel = String(relativePath).replace(/\\/g, '/').replace(/^\/+/, '')
  if (rel.startsWith('photos/')) rel = rel.slice('photos/'.length)
  return `/api/media/raw?path=${encodeURIComponent(rel)}`
}

export function mediaPhotoUrl(itemId) {
  return itemId != null ? `/api/media/photo/${itemId}` : null
}

export function mediaGeneratedUrl(genId) {
  return genId != null ? `/api/media/generated/${genId}` : null
}

// Generated images are stored at OUTPUT_DIR/<restaurant>/<filename>.
export function mediaGenFileUrl(restaurantName, filename) {
  if (!filename) return null
  return mediaRawUrl(`${restaurantName || ''}/${filename}`.replace(/^\/+/, ''))
}

export async function fetchBlobUrl(url) {
  if (!url) return null
  if (cache.has(url)) return cache.get(url)
  if (inflight.has(url)) return inflight.get(url)
  const p = (async () => {
    const token = await getAuthToken()
    const res = await axios.get(url, {
      responseType: 'blob',
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    })
    const obj = URL.createObjectURL(res.data)
    cache.set(url, obj)
    return obj
  })()
  inflight.set(url, p)
  try {
    return await p
  } finally {
    inflight.delete(url)
  }
}
